import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
  selector: 'app-search-location-no-results',
  templateUrl: './search-location-no-results.component.html',
  styleUrls: ['./search-location-no-results.component.css']
})
export class SearchLocationNoResultsComponent implements OnInit {

  q = '';
  lat?: number;
  lng?: number;
  country = '';

  options = {
    fields: ['name', 'geometry.location', 'address_components', 'formatted_address']
  };

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.q = params.q || '';
      this.lat = params.lat ? parseFloat(params.lat) : undefined;
      this.lng = params.lng ? parseFloat(params.lng) : undefined;
      this.country = params.country || '';
    });
  }

  public handleAddressChange(address: Address) {
    this.lat = address.geometry.location.lat();
    this.lng = address.geometry.location.lng();
    this.q = address.formatted_address;
    const filtered_array = address?.address_components?.filter(function (address_component) {
      return address_component.types.includes('country');
    });
    this.country = filtered_array?.length ? filtered_array[0].long_name : '';
  }

  search(): void {
    if (!this.q) return;
    this.router.navigate(['/search-results-location'], {
      queryParams: { q: this.q, lat: this.lat, lng: this.lng, country: this.country }
    });
  }

  clearSearch(): void {
    this.q = '';
    this.lat = undefined;
    this.lng = undefined;
    this.country = '';
  }
}
